module.exports = __webpack_public_path__ + "img/file-----3289-1x-png-9@1x.173ab2cf.png";